import api, { ApiResponse } from './api';

export interface Shift {
  id: number;
  name: string;
  startTime: string;
  endTime: string;
  workHours: number | null;
  breakMinutes?: number;
  crossesMidnight?: boolean;
  restDayCount?: number;
  isActive: boolean;
  createdDate: string;
  employeeCount: number;
}

export interface ShiftCreateDto {
  name: string;
  startTime: string;
  endTime: string;
  workHours?: number;
  // 2026-08-14: kesirli sureler icin dakika (10,5 saat = 630)
  workMinutes?: number;
  breakMinutes?: number;
  crossesMidnight?: boolean;
  restDayCount?: number;
}

export interface ShiftUpdateDto {
  name: string;
  startTime: string;
  endTime: string;
  workHours?: number;
  // 2026-08-14: kesirli sureler icin dakika (10,5 saat = 630)
  workMinutes?: number;
  breakMinutes?: number;
  crossesMidnight?: boolean;
  restDayCount?: number;
  isActive: boolean;
}

export interface ShiftEmployee {
  id: number;
  firstName: string;
  lastName: string;
  fullName: string;
  departmentName: string;
  startDate: string;
  endDate: string | null;
}

export interface EmployeeShift {
  id: number;
  shiftID: number;
  shiftName: string;
  startTime: string;
  endTime: string;
  workHours: number | null;
  startDate: string;
  endDate: string | null;
  notes: string | null;
}

export interface ShiftAssignDto {
  employeeId: number;
  shiftId: number;
  startDate?: string;
  endDate?: string;
  notes?: string;
}

const shiftService = {
  getAll: async (): Promise<ApiResponse<Shift[]>> => {
    return api.get('/shifts');
  },

  getById: async (id: number): Promise<ApiResponse<Shift>> => {
    return api.get(`/shifts/${id}`);
  },

  create: async (data: ShiftCreateDto): Promise<ApiResponse<{ id: number }>> => {
    return api.post('/shifts', data);
  },

  update: async (id: number, data: ShiftUpdateDto): Promise<ApiResponse<{ id: number }>> => {
    return api.put(`/shifts/${id}`, data);
  },

  delete: async (id: number): Promise<ApiResponse<{ id: number }>> => {
    return api.delete(`/shifts/${id}`);
  },

  getEmployees: async (shiftId: number): Promise<ApiResponse<ShiftEmployee[]>> => {
    return api.get(`/shifts/${shiftId}/employees`);
  },

  getEmployeeShift: async (employeeId: number): Promise<ApiResponse<EmployeeShift | null>> => {
    return api.get(`/shifts/employee/${employeeId}`);
  },

  assignShift: async (dto: ShiftAssignDto): Promise<ApiResponse<{ id: number }>> => {
    return api.post('/shifts/assign', dto);
  },

  removeEmployeeShift: async (employeeId: number): Promise<ApiResponse<{ employeeId: number }>> => {
    return api.delete(`/shifts/employee/${employeeId}`);
  },
};

export default shiftService;
